<template>
  <vuex-table :fields="fields" table_store="autocaller_v2/operators/table">
    <template slot="login" slot-scope="{ item }">
      <tooltip :content="$t('shared.component.v-copy.copy')" placement="right" trigger="hover">
        <span class="flex copy-row" @click="copy(item.login)">
          {{ item.login }}
          <icon type="md-copy" size="20" />
        </span>
      </tooltip>
    </template>
    <template slot="password" slot-scope="{ item }">
      <operators-pass :password="item.password" :is_collapse="false" />
    </template>
    <template slot="wrtc" slot-scope="{ item }">
      <icon :type="item.wrtc ? 'md-checkmark' : 'md-close'" size="18" />
    </template>
    <template slot="active" slot-scope="{ item }">
      <switch-status :id="item.id" :key="item.id" :value="item" />
    </template>
    <template slot="instance_id" slot-scope="{ item }">
      <operators-host :instance_id="item.instance_id" :regions="regions" />
    </template>
    <template slot="actions" slot-scope="{ item }">
      <table-dropdown>
        <span class="dropdown-item-icon dropdown-item-icon--edit" @click="edit(item)">
          {{ $t('shared.component.table.action.edit') }}
        </span>
        <span
          v-if="!item.active"
          class="dropdown-item-icon dropdown-item-icon--trash"
          @click="remove(item)"
        >
          {{ $t('shared.component.table.action.delete') }}
        </span>
      </table-dropdown>
    </template>
  </vuex-table>
</template>

<script>
  import SwitchStatus from './operators-editbale-status';
  import OperatorsPass from './operators-pass-info';
  import OperatorsHost from './operators-host';
  import { OperatorsModalService } from '@autocaller_v2/modals/OperatorsModalService';
  import { InstanceService } from '@autocaller_v2/services/InstanceService';
  import { mapActions } from 'vuex';
  export default {
    components: { SwitchStatus, OperatorsPass, OperatorsHost },
    data() {
      return {
        regions: [],
        key: false
      };
    },
    computed: {
      fields() {
        return [
          {
            key: 'id',
            label: this.$t('autocaller_v2.operators.field.id')
          },
          {
            key: 'login',
            label: this.$t('autocaller_v2.operators.field.login'),
            sortable: true,
            thStyle: { width: '250px' }
          },
          {
            key: 'password',
            label: this.$t('autocaller_v2.operators.field.pass'),
            thStyle: { width: '150px' }
          },
          {
            key: 'campaigns',
            label: this.$t('autocaller_v2.operators.field.campaigns_name'),
            sortable: true,
            thStyle: { width: '120px' },
            formatter: (value) => value.map((val) => val.name).join(', ')
          },
          {
            key: 'weight',
            label: this.$t('autocaller_v2.operators.field.weight'),
            sortable: true
          },
          {
            key: 'active',
            label: this.$t('autocaller_v2.operators.field.status'),
            sortable: true
          },
          {
            key: 'wrtc',
            label: this.$t('autocaller_v2.operators.field.wrtc'),
            sortable: false,
            class: 'text-center'
          },
          {
            key: 'instance_id',
            label: this.$t('autocaller_v2.operators.field.instance'),
            sortable: false
          },
          {
            key: 'created_at',
            label: this.$t('autocaller_v2.operators.field.created_at'),
            sortable: true
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center',
            thStyle: { width: '120px' }
          }
        ];
      }
    },
    created() {
      InstanceService.getList().then((data) => {
        this.regions = data || [];
      });
    },
    methods: {
      ...mapActions('autocaller_v2/operators/table', ['getAsyncData']),
      copy: function (value) {
        this.$copyText(value).then(() => {
          this.$noty.success(this.$t('shared.component.noty.text_copied'));
        });
      },
      remove(item) {
        OperatorsModalService.remove(item.id, item).on('success', () => this.getAsyncData());
      },
      edit(item) {
        OperatorsModalService.edit(item.id, item).on('success', () => this.getAsyncData());
      }
    }
  };
</script>
